import { gql } from 'apollo-angular';

import { CONFIGURATION_VARIABLE_FRAGMENT } from 'graphql/fragments/configuration-variable';

export const PRODUCT_LINE_VARIABLES_FRAGMENT = gql`
  fragment ProductLineVariablesFragment on ProductLine {
    configuration {
      # To be removed after Filterpage step2 is reworked, only used to show dm version in configuration for testers
      datamodelVersion: variable(id: "Filter.Version") {
        version: property(name: "CalculatedValue") { valueText }
      }
      sections(filter: { isVisible: true }) {
        id
        name
        showFilterProp: property(name: "showFilter") {
          valueText
        }
        sections (flatten: true) {
          id
          name
          showFilterProp: property(name: "showFilter") {
            valueText
          }
          variables: filteredVariables(paging: { page: 0, perPage: 250 }, filter: { isVisible: true }) {
            items {
              ...ConfigurationVariableFragment
            }
          }
        }
      }
    }
  }
  ${CONFIGURATION_VARIABLE_FRAGMENT}
`;
